import { OfficeHeader, Tabs } from 'components'

import { FC } from 'react'
import NICProposalTab from './tabs/nic-proposal'
import PaymentAllocationScheduleTab from './tabs/payment-allocation-schedule'
import PaymentAllocationTab from './tabs/payment-allocation'
import PremiumTransferScheduleTab from './tabs/premium-transfer-schedule'
import { useUrlState } from 'utils'

type Props = {}

const tabs: any[] = [
    // { name: "Premium transfer schedule", href: "PREMIUM_TRANSFER_SCHEDULE" },
    { name: "Payment allocation schedule", href: "PAYMENT_ALLOCATION_SCHEDULE" },
    // { name: "Payment Allocation", href: "PAYMENT_ALLOCATION" },
]

const TreatySchedulePage: FC<Props> = () => {
    const [activeTab] = useUrlState("orderStatus");

    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <OfficeHeader />
            <Tabs tabs={tabs} orderStatus={activeTab} defaultTab={"Premium transfer schedule"} />
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  p-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    {!activeTab && <PremiumTransferScheduleTab />}
                    {activeTab === "PREMIUM_TRANSFER_SCHEDULE" && (
                        <PremiumTransferScheduleTab />
                    )}
                    {activeTab === "PAYMENT_ALLOCATION_SCHEDULE" && (
                        <PaymentAllocationScheduleTab />
                    )}
                    {activeTab === "PAYMENT_ALLOCATION" && (
                        <PaymentAllocationTab />
                    )}
                </div>
            </div>
        </main>
    )
}

export default TreatySchedulePage